import { IconButton, useTheme } from "@mui/material";
import React, { ReactNode } from "react";

export type CriteriaIconButtonProps = {
  icon: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  "aria-label"?: string;
};

export const CriteriaIconButton = (props: CriteriaIconButtonProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <IconButton
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props["aria-label"]}
      className={isDark ? "bg-teamApp-dark-surface" : "bg-white"}
      sx={{
        width: "2.5rem",
        height: "2.5rem",
      }}
    >
      {props.icon}
    </IconButton>
  );
};
